import React, { Component } from 'react';
import axios from 'axios';
import './styles/App.css';
import isURL from 'validator/lib/isURL';
import isEmail from 'validator/lib/isEmail';

class AdvertisingEnquiry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      message: "",
      website: "",
      nameValid: false,
      emailValid: false,
      websiteValid: false,
      messageValid: false,
    }

    this.submit = this.submit.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleWebsiteChange = this.handleWebsiteChange.bind(this);
  }

  handleNameChange(event) {
    var name = event.target.value;
    this.setState({ name: name, nameValid: name.length > 0 });
  }

  handleEmailChange(event) {
    var email = event.target.value;
    this.setState({ email: email, emailValid: isEmail(email) });
  }

  handleMessageChange(event) {
    var message = event.target.value;
    this.setState({ message: message, messageValid: message.length > 0 });
  }

  handleWebsiteChange(event) {
    var website = event.target.value;
    this.setState({ website: website, websiteValid: isURL(website) });
  }

  submit(event) {
    event.preventDefault();

    axios.post(process.env.REACT_APP_API + '/api/contact/', { name: this.state.name, email: this.state.email, message: this.state.message, website: this.state.website })
    .then((response) => {
      this.setState({ name: "", email: "", message: "", website: "", websiteValid: false });
      alert(response.data);
    })
    .catch((error) => {
      alert("An error occurred. We apologize for the inconvenience!");
    });
  }

  render() {
    return (
      <div className="suggest-div">
      <form onSubmit={this.submit}>
      <h2>Advertise on ModelZoo</h2>
      <p>We offer a variety of advertising options, from traditional banner and sidebar ads on our website to the home page section where advertisers can choose to highlight their post.</p>
      <p>If you'd like to partner with ModelZoo to reach our audience you can contact us using the form below.</p>
      <hr/>

      <div className="form-group">
      <label htmlFor="suggestion-name">Name *</label>
      <input required type="text" className="form-control" id="suggestion-name" placeholder="" value={this.state.name} onChange={this.handleNameChange} />
      </div>

      <div className="form-group">
      <label htmlFor="suggestion-email">Email *</label>
      <input required type="text" className={"form-control " + (this.state.email.length === 0 ? "" : (this.state.emailValid ? "is-valid" : "is-invalid"))} id="suggestion-email" placeholder="info@website.com" value={this.state.email} onChange={this.handleEmailChange} />
      { this.state.email.length === 0 ?
        "" :
        <div className={ this.state.emailValid ? "valid-feedback" : "invalid-feedback" }>
        { this.state.emailValid ? "" : "Please enter a valid email!" }
        </div>
      }
      </div>

      <div className="form-group">
      <label htmlFor="suggestion-website">Website</label>
      <input type="text" className={"form-control " + (this.state.website.length === 0 ? "" : (this.state.websiteValid ? "is-valid" : "is-invalid"))} id="suggestion-website" placeholder="https://modelzoo.co" value={this.state.website} onChange={this.handleWebsiteChange} />
      { this.state.website.length === 0 ?
        "" :
        <div className={ this.state.websiteValid ? "valid-feedback" : "invalid-feedback" }>
        { this.state.websiteValid ? "" : "Please enter a valid URL!" }
        </div>
      }
      </div>

      <div className="form-group">
      <label htmlFor="suggestion-message">Message *</label>
      <input type="text" className="form-control" id="suggestion-message" value={this.state.message} onChange={this.handleMessageChange} />
      </div>

      <div align="center">
      <input className="btn btn-primary" type="submit" disabled={!(this.state.nameValid && this.state.emailValid && this.state.messageValid && (this.state.websiteValid || this.state.website.length === 0))} value="Submit"/>
      </div>
      </form>
      </div>
    )
  }
}

export default AdvertisingEnquiry;


// WEBPACK FOOTER //
// ./src/AdvertisingEnquiry.jsx